import type { QueueState } from './useWriteQueue';

interface Props {
  state: QueueState;
  onOpen: () => void;
}

export function QueueIndicator({ state, onOpen }: Props) {
  if (!state.configured) {
    return <p className="font-mono text-[0.7rem] text-graphite-500">queue offline</p>;
  }
  const failed = state.failedRetry + state.failedTerminal;
  if (failed > 0) {
    return (
      <button
        type="button"
        onClick={onOpen}
        className="rounded-md border border-signal-amber/50 bg-signal-amber/10 px-2 py-1 font-mono text-[0.7rem] text-signal-amber hover:bg-signal-amber/20"
      >
        {failed} unsynced — click to retry
      </button>
    );
  }
  if (state.pending > 0) {
    return (
      <button
        type="button"
        onClick={onOpen}
        className="font-mono text-[0.7rem] text-graphite-500 hover:text-graphite-900"
      >
        syncing {state.pending} …
      </button>
    );
  }
  return <p className="font-mono text-[0.7rem] text-graphite-500">queue clear</p>;
}
